import { Component, Input, TemplateRef } from "@angular/core";
import { NbIconComponent } from "@nebular/theme";

@Component({
    selector: "kno2-action-bar",
    templateUrl: "./action-bar.component.html",
    styleUrls: ["./action-bar.component.scss"],
    standalone: false
})
export class ActionBarComponent {
    public titleRef: TemplateRef<any> = null;
    public titleText: string = null;
    @Input() public set title(value: string | TemplateRef<any>) {
        if (value instanceof Object) this.titleRef = <TemplateRef<any>>value;
        else this.titleText = value;
    }
    @Input() public titleIcon?: TemplateRef<NbIconComponent>;
    @Input() public contentCenter?: TemplateRef<any>;
    @Input() public contentRight: TemplateRef<any>;
}
